export * from "./MainPage";
export * from "./selectors";
export * from "./ReportPage";

export const BASE_API_URL = "https://api.menuoff.com/v1/";
export const BASE_URL = "https://ssadmin.menuoff.com/";
